import Tooltip from './Tooltip';

export { withTooltip } from './Tooltip';

export default Tooltip;
